export default "__VITE_ASSET__B64Nx8gy__"